interface CookieOptions {
  expires?: number;
  domain?: string;
  path?: string;
  secure?: boolean;
}

export const getCookie = (name: string): string | undefined => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : undefined;
};

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

  if (options.expires) {
    const date = new Date(Date.now() + options.expires * 864e5);
    cookie += `; expires=${date.toUTCString()}`;
  }
  if (options.domain) cookie += `; domain=${options.domain}`;
  cookie += `; path=${options.path || '/'}`;
  if (options.secure) cookie += '; secure';

  document.cookie = cookie;
};
